import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPost } from '../../types/BlogTypes';
import { formatBlogDate } from '../../utils/blogUtils';
import '../../assets/styles/Blog.css';

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  return (
    <Link to={`/blog/${post.id}`} className="blog-card" style={{ textDecoration: 'none', color: 'inherit' }}>
      <img 
        src={post.image || '/images/blog/default.jpg'} 
        alt={post.title} 
        className="blog-card-image"
        onError={(e) => {
          // Use a default image if the specified image fails to load
          (e.target as HTMLImageElement).src = '/images/blog/default.jpg';
        }}
      />
      <div className="blog-card-content">
        <h3 className="blog-card-title">{post.title}</h3>
        <p className="blog-card-date">{formatBlogDate(post.date)}</p>
        <p className="blog-card-summary">{post.summary}</p>
        <span className="blog-card-link">Read More</span>
      </div>
    </Link>
  );
};

export default BlogCard; 